import { DocumentChangeType } from 'firebase/firestore';

export type AppChangeType = 'skipped' | DocumentChangeType;
export type ChangeTyped<T> = T & { changeType?: AppChangeType };
